<template>
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms" style="margin-top: -20px">
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-flex lg4 sm6>          
            <v-card pa-0>                            
              <v-card-text class="">
                <v-form v-model="valid">
                  <v-layout>
                    <v-flex xs8>
                      <v-text-field
                        box
                        label="Name"
                        name="name"                              
                        v-model="formModel.name"
                        v-validate="'required'"
                        data-vv-name="name"     
                        v-bind:error-messages="errors.collect('name')"  
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field
                        box
                        label="Tahun"
                        type="number"
                        name="name"                              
                        v-model="formModel.tahun"
                        v-validate="'required'"
                        data-vv-name="tahun"     
                        v-bind:error-messages="errors.collect('tahun')"  
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  
                  <v-select
                    box
                    v-bind:items="modes"
                    v-validate="'required'"
                    data-vv-name="mode"     
                    v-bind:error-messages="errors.collect('mode')"           
                    v-model="formModel.mode"
                    label="Mode"    
                    required
                    item-text="name"
                    item-value="id"                            
                  ></v-select>
                  
                  <v-select
                    box
                    v-bind:items="tingkats"
                    v-validate="'required'"
                    data-vv-name="tingkat"     
                    v-bind:error-messages="errors.collect('tingkat')"           
                    v-model="formModel.tingkat"
                    label="Tingkat"    
                    required
                    item-text="name"
                    item-value="id"        
                    v-on:change="formModel.area_id = null"
                  ></v-select>
                  
                  <v-autocomplete
                    box
                    v-bind:items="area.items"
                    v-bind:filter="customFilter"                      
                    v-bind:search-input.sync="area.search"
                    item-text="name"
                    item-value="id"
                    v-model="formModel.area_id"
                    label="Area ID"                    
                    hide-no-data clearable
                    v-bind:loading="area.loading"                          
                  ></v-autocomplete>  
                  
                  <v-text-field v-model="formModel.color" label="Color" solo></v-text-field>
                  <slider-picker v-model="colors" style="width:100%" />
                  
                  <v-switch 
                    v-bind:label="formModel.status === 1 ? 'Status Active' : 'Status Inactive'" 
                    v-bind:true-value="1"
                    v-bind:false-value="0"
                    hide-details
                    v-model="formModel.status">                      
                  </v-switch>                                    
                  
                  <v-switch 
                    v-bind:label="formModel.visibility === 1 ? 'Visible' : 'Invisible'" 
                    v-bind:true-value="1"
                    v-bind:false-value="0"                    
                    v-model="formModel.visibility">                      
                  </v-switch>
                  
                  <v-textarea
                    box
                    label="Description"                                                  
                    v-model="formModel.desc"                      
                  ></v-textarea>                                    

                  <div class="form-btn">
                      <v-btn v-if="!isUpdate" @click="save(isUpdate)" color="success" v-bind:loading="loading" >Create</v-btn>
                      <v-btn v-else @click="save(isUpdate)" color="primary" v-bind:loading="loading">Update</v-btn>                                                                    
                      
                  </div>                                                                     
                </v-form>  
              </v-card-text>       
            </v-card>
          </v-flex>            
        </v-layout>
      </v-container>
    </div>
  </v-slide-y-transition>
</template>

<script>  
import Kompetisi from '@/apps/frc/models/Kompetisi';    
import {Slider}  from 'vue-color';
import direct    from '@/util/directives';

var model = new Kompetisi();

export default {
    directives : direct, 
    components: {
      'slider-picker': Slider,
    },
    $_veeValidate: {
        validator: 'new'
    },    
    data: () => ({
        
        isEditing:true,
        isUpdate:false,
        formModel: {          
          id : null,
          name : null,
          tahun : null,
          mode : null,
          tingkat : null,
          area_id : null,
          desc : null,
          visibility : 1,
          color: '#ffffff',
          status : 1,            
        },
        //countries: Countries,
        modes: [],
        status: [],
        tingkats: [],
        area : {
           items : [],
           search : null,
           loading : false,
        },
        colors:{hex:'#40BF80'},
        valid: true,
        detail:[],
        headersDtl:[
          {text:'No', value:'no'},
          {text:'Dapil', value:'dapil_id'},
          {text:'Kuota', value:'kuota'},
          {text:'Del', value:'del', align:'right'},
        ], 
        alert : null,
        loading : false,
        dapils : [],
        dapil_id : null,
    }),
    watch:{
      formModel:{
        handler(newVal){
          this.colors = {hex:newVal.color};
          if(newVal.tingkat!==null){
            this.area.loading = true;            
            model.areas({'AreaSearch[id]':newVal.area_id,tingkat :newVal.tingkat}).then(res=>{                             
              this.area.items = res;              
              this.area.loading = false;
            });            
            
            if(newVal.mode === 2 || newVal.mode === 3){     
              if(newVal.tingkat === 0){
                model.dapils().then(res=>{                
                  this.dapils = res.data;
                });
              } else {
                model.dapils({'DapilSearch[area_id]':newVal.area_id,'DapilSearch[tingkat]' :newVal.tingkat}).then(res=>{                
                  this.dapils = res.data;
                });
              }
            }
          }
        },
        deep:true
      },
      dapil_id(newVal){
        if(newVal){
          var ketemu = false;
          this.formModel.kompetisiDapils.forEach(item=>{
            if(item.dapil_id === newVal) ketemu = true;
          });
          if(!ketemu){
            this.newDtl({dapil_id : newVal, kuota:0});                     
          }
          var ctx=this; setTimeout(function(){ctx.dapil_id = null;},500);
        }
      },
      colors(newVal){this.formModel.color = newVal.hex;}
    },
    created () {
      model.tingkats().then(res=>{this.tingkats=res;});  
      model.modes().then(res=>{this.modes=res;});  
      this.$watch(['area','search'].join('.'),(newVal)=>{if(newVal && this.formModel.tingkat){        
        this.area.loading = true;
        model.areas({tingkat:this.formModel.tingkat, 
          'AreaSearch[name]':newVal}).then(res=>{this.area.items=res; this.area.loading = false;});
      }});      
    },    
    mounted () {this.init();}, 
    methods : {
        init(){
            if(this.$route.query.id){
                this.isUpdate  = true; this.loading = true;
                model.one({id : this.$route.query.id }).then(data => {                     
                    Object.assign(this.formModel, data === null ? {}:data);        
                    //this.formModel.kompetisiDapil.forEach((item,i)=>{this.newDtl(item, i);});
                    this.checking(data);
                    this.loading = false;
                });                                               
            }            
            this.$validator.localize('en', this.dictionary);       
        },
        
        async save(isUpdate = false) {                
            this.$validator.validateAll();    
            this.formModel.time = this.$moment().valueOf();
            this.formModel.info = null;
            if( !this.errors.any() ) {  this.loading = true;
                var res = isUpdate ? await model.update(this.formModel): await model.create(this.formModel);                
                if(res.status === 200){   
                    this.$swal({ type: 'success', title: 'Your work has been saved', showConfirmButton: false, timer: 1000});                
                    this.$router.go(-1);                    
                } else {
                    var title = res.status ? '#'+res.status + ' Oops...' : 'Oops...';
                    var text  = res.statusText ? res.statusText: 'Something happened in setting up the request that triggered an Error.';                     
                    if(res.data){ if(res.data.message){ text += ' ' + res.data.message; } else {this.validate(res.data);}}                
                    this.$swal({type: 'error', title: title, text: text});                    
                }  this.loading = false;
            }             
        },
       
        validate(data){
            data.forEach( (item) => {
                this.$validator.errors.add({field : item.field,msg : item.message});
            });
        },        
                
        checking(data){
            if(data.info){
                if(data.info.action === 'synch' && data.info.data){
                    this.validate(data.info.data);
                }
            }            
        },        
                
        clear () {
            this.formModel = {};
            this.$validator.reset();
        },
    
        customFilter (item, queryText, itemText) {
            const textOne = item.name.toLowerCase()
            //const textTwo = item.abbr.toLowerCase()
            const searchText = queryText.toLowerCase()
            return textOne.indexOf(searchText) > -1; 
        },       
        
        nameDapil(id){
          var result = '';
          this.dapils.forEach(item=>{if(id === item.id){result = item.name}});
          return result;
        },    
    
        
        newDtl(d = null, i = null){
            this.notMagic();               
            this.formModel.kompetisiDapils.push({        
              //id : d ? d.id : null,
              dapil_id : d ? d.dapil_id : null,
              kuota : d ? d.kuota : 0,
              magic : true,        
            });                                                  
        },
        
        delDtl(props){            
            this.formModel.kompetisiDapils.splice(props.index, 1);   
            this.detail.splice(props.index, 1);   
        }, 

        isMagic(props){     
            props.item.magic = true;
            this.notMagic(props.index);            
        },

        notMagic(exc = null){
            this.formModel.kompetisiDapils.forEach((item, index)=>{
                if(exc !== index){
                    this.formModel.kompetisiDapils[index].magic = false;
                }
            });               
        } 
    }
}
</script>